import { connect } from 'react-redux';
import WorkDetails from './work_details';
import PapersMenuAdapter from './papers_menu_adapter';
import {
  setWorkSize, setFrame, removeFromCanvas, setNonGlare
} from '../../actions/canvas';
import { hide } from '../../actions/current_index';
import { addToCart } from '../../actions/cart';
import { showMoreLikeThis } from '../../actions/more_like_this';

const mapStateToProps = ({ workDetails, canvas: { works }, currentIndex }) => {
  const work = works[currentIndex] || {};
  const details = (work.workId ? workDetails[work.workId] : {}) || {};
  const framingOptions = work.workId
    ? ((details.workSizes || []).find((ws) => ws.id === work.workSizeId) || {}).options || []
    : [];
  return ({
    ...work,
    ...details,
    framingOptions,
    index: currentIndex
  });
};

// Create Props for the PapersMenuAdapter
const mapPapersMenuAdapterProps = ({ workDetails, canvas: { works }, currentIndex }) => {
  const work = works[currentIndex] || {};
  const details = (work.workId ? workDetails[work.workId] : {}) || {};
  const {
    workSizeId, frameId, nonGlare, workId
  } = work;
  const {
    workSizes, thumbnails, currency, landscape
  } = details;

  return {
    workSizes,
    workSizeId,
    frameId,
    nonGlare,
    thumbnails,
    currency,
    landscape,
    workId,
    index: currentIndex
  };
};

// Exports both the original WorkDetails connector and the new PapersMenuAdapter connector
export default connect(mapStateToProps, {
  setFrame, setWorkSize, hide, removeFromCanvas, addToCart, showMoreLikeThis, setNonGlare
})(WorkDetails);

export const ConnectedPapersMenuAdapter = connect(
  mapPapersMenuAdapterProps,
  (dispatch, ownProps) => ({
    setFrame: (frameId) => dispatch(setFrame(frameId, ownProps.index)),
    setWorkSize: (workSizeId) => dispatch(setWorkSize(workSizeId, ownProps.index)),
    setNonGlare: (value) => dispatch(setNonGlare(value, ownProps.index))
  })
)(PapersMenuAdapter);
